// src/AppRoutesTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./utils/snap";

export default function AppRoutesTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(); // SNAP PAGE_VIEW لكل Route
  }, [location.pathname]);
  return null;
}
